// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-181b9977] .v-list-item__title,[data-v-181b9977] .v-list-item__subtitle {\n  overflow: initial;\n  text-overflow: initial;\n  white-space: initial;\n}", ""]);
// Exports
module.exports = exports;
